import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Observable } from 'rxjs/Observable';
import { MODO_PERSPECTIVA_ITENS_MENU_USUARIO, PERMISSAO_ITENS_MENU_USUARIO } from '../../../app.constants';
import { ItemMenu } from '../../shared/dominios/item-menu';
import { CardModel } from '../../shared/models/card.model';
import { PaginaCardsModel } from '../../shared/models/pagina-cards.model';
import { FuncoesCardMenu } from '../../shared/util/funcaoes-card-menu/funcoes-card-menu';
import { StorafeUtil } from '../../shared/util/storasge.util';

@Component({
  selector: 'app-card-menu-pessoal',
  templateUrl: './card-menu-pessoal.component.html',
  styleUrls: ['./card-menu-pessoal.component.css']
})
export class CardMenuPessoalComponent implements OnInit {

  param = '/home';
  @BlockUI() blockUi: NgBlockUI;

  cdCentrus: number;

  dadosCards: any;

  disabled = false;


  paginaCards: PaginaCardsModel[] = [];

  itemMenu$: Observable<ItemMenu[]>;

  constructor(
    private funcoesCardMenu: FuncoesCardMenu,
    private store: Store<ItemMenu>) {
    this.itemMenu$ = store.pipe(select('itemMenuLista'));
  }

  ngOnInit() {
    this.getCardsMenu();

    const modoConsultadoUusario = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);

    const permitirAcessoItensMenuUsuario = StorafeUtil.recuperarSessionStorage(PERMISSAO_ITENS_MENU_USUARIO);
    if (modoConsultadoUusario) { (permitirAcessoItensMenuUsuario) ? (this.disabled = false) : (this.disabled = true) }
  }


  async getCardsMenu() {
    this.blockUi.start('Carregando...');
    try {
      this.paginaCards = await this.funcoesCardMenu.listarItensMenu();

    } catch (error) {
      console.error(error);
    } finally {
      this.blockUi.stop();
    }
  }

  // Dados Cadastrais



  direcionar(dadosCards: CardModel): void {
    this.funcoesCardMenu.direcionar(dadosCards);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/card-menu/card-menu-pessoal/card-menu-pessoal.component.ts